export default "__VITE_ASSET__Ce2NtAk6__"